module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client-bcafbdb61c4a1f08c0e4bb84dd355f48.png";